import React from 'react'
import { observer } from 'mobx-react'
import HelpOverlay from '../../utils/helpOverlay'
import OmdbModalForm from './omdbModalForm'

@observer
export default class OMDBButton extends React.Component {
  render () {
    const { store, disabled } = this.props
    const entity = store.cv.record
    const enabled = !disabled && entity.has('imdb_id') && entity.get('imdb_id')
    const imdbURL = entity.has('imdb_id') && entity.get('imdb_id') &&
     entity.get('imdb_id').length > 3 &&
    'https://www.imdb.com/title/' + entity.get('imdb_id').trim().concat('/')

    return (
      <React.Fragment>
        <button
          type='button'
          className='btn btn-primary btn-info'
          onClick={() => store.cv.omdb.getDataFromOMDBAPI({ imdb_id: entity.get('imdb_id') })}
          disabled={!enabled}>
          <span className='glyphicon glyphicon-cloud-download'/>&nbsp;{store.__('Download OMDb data')}
          <HelpOverlay store={store} path='films/common/download_omdb_button' />
        </button>
        {imdbURL && <p style={{ marginTop: '0.6em' }}>
          <a href={imdbURL} className='text-muted' target='_blank' rel='noreferrer'>
            <i className='glyphicon glyphicon-link' /> {imdbURL}
          </a>
        </p>}
        <OmdbModalForm store={store} />
      </React.Fragment>
    )
  }
}
